import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { RollIdProvider } from "../CommonComponents/RollIdContext";
import AccSidebar from "../CommonComponents/Accumulativesidebar";
import { FaBars, FaTimes } from "react-icons/fa";
import RollIdPrompt from "../CommonComponents/RollIdPrompt";
import MainContent from "../Incoming/IncomingComponents/MainContent";
import Tabs from "../CommonComponents/Tabs";

const ReversalAccumulativeRequest = () => {
  const navigate = useNavigate();
  const { userType } = useParams();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [rollId, setRollId] = useState("");

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleRollIdSubmit = (id) => {
    setRollId(id);
  };

  useEffect(() => {
    if (!userType || (userType !== "hgo" && userType !== "monazam")) {
      // Redirect to an error page or a default page if the userType is invalid
      navigate("/");
    }
  }, [userType, navigate]);

  return (
    <RollIdProvider>
      <div className="dashboard-layout d-flex">
        <AccSidebar
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          rollId={rollId}
        />
        <div className={`main-content ${isSidebarOpen ? "blurred" : ""}`}>
          <div className="d-md-none d-flex align-items-center sidebar-logo-bg py-3 px-1">
            <button className="btn" onClick={toggleSidebar}>
              {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
            <img
              src="/assets/logo.png"
              alt="Logo"
              className="img-fluid logo pe-5"
              style={{ height: "40px" }}
            />
          </div>
          <RollIdPrompt onRollIdSubmit={handleRollIdSubmit} />
          <div className="mt-3">
            <Tabs />
          </div>
          <MainContent rollId={rollId} reversalAccumulativeRequest />
        </div>
      </div>
    </RollIdProvider>
  );
};

export default ReversalAccumulativeRequest;
